import axios from "axios";

const baseUrl = () => process.env.REACT_APP_BASE_URL || "";

function buildHeaders() {
  const headers = { "Content-Type": "application/json" };
  const syncSecret = process.env.REACT_APP_SYNC_SECRET;
  if (syncSecret) {
    headers["X-Sync-Secret"] = syncSecret;
  }
  return headers;
}

function credentialsPayload({ storeId, email, password }) {
  return {
    storeId,
    email,
    password,
  };
}

const SubscriptionService = {};

SubscriptionService.getPackages = function () {
  return axios.get(`${baseUrl()}/api/packages`, {
    headers: buildHeaders(),
  });
};

SubscriptionService.getDetails = function ({ storeId, email, password }) {
  return axios.post(
    `${baseUrl()}/api/checkout/subscription/details`,
    credentialsPayload({ storeId, email, password }),
    { headers: buildHeaders() }
  );
};

SubscriptionService.renew = function ({ storeId, email, password, interval = "yearly" }) {
  return axios.post(
    `${baseUrl()}/api/checkout/subscription/renew`,
    {
      ...credentialsPayload({ storeId, email, password }),
      interval,
    },
    { headers: buildHeaders() }
  );
};

SubscriptionService.upgrade = function (payload) {
  return axios.post(
    `${baseUrl()}/api/checkout/subscription/upgrade`,
    payload,
    { headers: buildHeaders() }
  );
};

// Legacy endpoint kept for cancel flow.
SubscriptionService.getLatest = function ({ storeId, email, password }) {
  return axios.post(
    `${baseUrl()}/api/checkout/get-latest-subscription`,
    credentialsPayload({ storeId, email, password }),
    { headers: buildHeaders() }
  );
};

SubscriptionService.cancel = function ({ storeId, email, password }) {
  return axios.post(
    `${baseUrl()}/api/checkout/cancel-subscription`,
    credentialsPayload({ storeId, email, password }),
    { headers: buildHeaders() }
  );
};

export default SubscriptionService;
